import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { CssSelectors, Layouts } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	billingIcon: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
	},
	buttonContainer: {
		...Layouts.horizontalStack(10),
	},
	container: {},
	formFieldLabel: {
		color: THEME.colors.text.light,
		display: 'inline-block',
		fontSize: '0.875rem',
		width: 200,
	},
	formFieldLabelWide: {
		width: '100%',
	},
	formFieldValue: {
		color: THEME.colors.text.main,
		fontSize: '0.875rem',
	},
	root: {
		padding: '1.25rem 0 7.5rem 0',
		...CssSelectors.allChildren(
			{
				marginTop: '1.25rem',
			},
			':not(:first-child)'
		),
	},
	sectionTitle: {
		marginTop: 0,
		marginBottom: THEME.spacing.sm,
	},
	sectionLead: {
		color: THEME.colors.text.main,
	},
	paymentSettings: {
		...CssSelectors.allChildren({}, 'div'),
	},
	customCheckbox: {
		// Remove the global override since we'll use a wrapper span
		transition: 'all 0.15s ease-in-out',
	},
	checkboxLabel: {
		color: THEME.colors.text.main,
		fontSize: 14,
		marginLeft: 20,
		transition: 'opacity 0.15s ease-in-out',
	},
	businessHoursContainer: {
		transition: 'opacity 0.15s ease-in-out',
	},
	businessHoursToggleContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
	},
	businessHoursExplanation: {
		backgroundColor: THEME.colors.info.light,
		color: THEME.colors.info.contrastText,
		fontSize: '0.8125rem',
		lineHeight: 1.4,
		maxWidth: 800,
		marginBottom: 10,
		padding: 12,
		borderRadius: 4,
	},
	validation: {
		color: THEME.colors.danger.main,
	},
	paymentContainer: {
		display: 'grid',
		gap: THEME.spacing.lg,
		width: '100%',
		gridTemplateColumns: '1fr',

		[`@media(min-width: ${THEME.breakpoints.xl}px)`]: {
			gridTemplateColumns: '1fr 1px 1fr',
		},
	},
	verticalDivider: {
		backgroundColor: THEME.colors.border.light,
		flexShrink: 0,

		height: 1,
		width: '100%',

		[`@media(min-width: ${THEME.breakpoints.xl}px)`]: {
			width: 1,
			height: '100%',
		},
	},
	stripeKeysSection: {
		minWidth: 0,
	},
	processingFeesSection: {
		minWidth: 0,
	},
});
